export class TreeCorrection {
  id: string;
  camera_id: string;
  treenumber: number;
  ath_correction = 0.0;
  atv_correction = 0.0;
}
